export const LEAN_POPUP_STORAGE_KEY = 'leanPopupEnabled'

export const readLeanPopupPreference = (): boolean => {
  try {
    return window.localStorage.getItem(LEAN_POPUP_STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

export const clearLeanPopupPreference = () => {
  try {
    window.localStorage.removeItem(LEAN_POPUP_STORAGE_KEY)
  } catch {
    // Storage unavailable: nothing is cached to clear.
  }
}

/** The `popup-settings` IPC payload; Electron picks the popup entry from it. */
export const buildPopupSettingsPayload = (callPopEnabled: boolean): string =>
  JSON.stringify({ callPopEnabled, leanPopup: readLeanPopupPreference() })
